export default class Palette {
    constructor(colors, name) {
        this.colors = colors;
        this.name = name;
    }

    isValid() {
        var result = true;

        if(result) result = this.name && this.colors && this.colors.length;

        return result;
    }
}